/* eslint-disable jsx-a11y/no-static-element-interactions */
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AssignmentIcon from "@mui/icons-material/Assignment"; // For License Tracker
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn"; // For Checklist
import BuildIcon from "@mui/icons-material/Build"; // For Maintenance
import DashboardIcon from "@mui/icons-material/Dashboard";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar"; // For Vehicles
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation"; // For Fueling
import LogoutIcon from "@mui/icons-material/Logout";
import PeopleIcon from "@mui/icons-material/People"; // For Users
import PersonIcon from "@mui/icons-material/Person";
import ReportIcon from "@mui/icons-material/Report"; // For Accidents
import TrafficIcon from "@mui/icons-material/Traffic"; // For Safety
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ColorContext } from "../../ColorContext/darkContext";
import waveline from "../../Images/waveline.jpg";
import "./Sidebar.scss";

function Sidebar() {
  // Color state management using React context
  const { darkMode, dispatch } = useContext(ColorContext);

  return (
    <div className="sidebar">
      <div className="logo">
        <Link to="/driver/dashboard" style={{ textDecoration: "none" }}>
          <img className="logo-image" src={waveline} alt="logo" />
        </Link>
      </div>

      <div className="links">
        <ul>
          <p className="spann">Main</p>
          <Link to="/admin/dashboard" style={{ textDecoration: "none" }}>
            <li>
              <DashboardIcon className="icon" /> Dashboard
            </li>
          </Link>

          <p className="spann">Lists</p>
          <Link to="/admin/orders" style={{ textDecoration: "none" }}>
            <li>
              <PersonIcon className="icon" /> Allocations
            </li>
          </Link>

          <Link to="/admin/safety" style={{ textDecoration: "none" }}>
            <li>
              <TrafficIcon className="icon" /> Safety
            </li>
          </Link>

          <Link to="/admin/maintenance" style={{ textDecoration: "none" }}>
            <li>
              <BuildIcon className="icon" /> Maintenance
            </li>
          </Link>

          <Link to="/admin/checklist" style={{ textDecoration: "none" }}>
            <li>
              <AssignmentTurnedInIcon className="icon" /> Checklist
            </li>
          </Link>

          <Link to="/admin/allowances" style={{ textDecoration: "none" }}>
            <li>
              <LocalGasStationIcon className="icon" /> Allowances
            </li>
          </Link>

          <Link to="/admin/fuelings" style={{ textDecoration: "none" }}>
            <li>
              <LocalGasStationIcon className="icon" /> Fueling
            </li>
          </Link>

          <Link to="/admin/accident" style={{ textDecoration: "none" }}>
            <li>
              <ReportIcon className="icon" /> Accidents
            </li>
          </Link>

          <Link to="/admin/license" style={{ textDecoration: "none" }}>
            <li>
              <AssignmentIcon className="icon" /> License Tracker
            </li>
          </Link>

          <p className="spann">Settings</p>
          <Link to="/admin/users" style={{ textDecoration: "none" }}>
            <li>
              <PeopleIcon className="icon" /> Users
            </li>
          </Link>

          <Link to="/admin/vehicle" style={{ textDecoration: "none" }}>
            <li>
              <DirectionsCarIcon className="icon" /> Vehicles
            </li>
          </Link>

          <Link to="/admin/customers" style={{ textDecoration: "none" }}>
            <li>
              <AccountCircleIcon className="icon" /> Customers
            </li>
          </Link>

          <Link to="/logout" style={{ textDecoration: "none" }}>
            <li>
              <LogoutIcon className="icon" /> Log Out
            </li>
          </Link>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;